import { render } from "./BlckConstituteFolder.vue?vue&type=template&id=17b058e6"
import script from "./BlckConstituteFolder.vue?vue&type=script&lang=js"
export * from "./BlckConstituteFolder.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__